import React, { useEffect, useState } from "react";
import { Drawer, Box, IconButton, CircularProgress } from "@mui/material";
import profilecross from "../../../../assets/profilecross.svg";
import CustomText, { textStyles } from "../../../../components/CustomText";
import down from "../../../../assets/down.svg";
import view from "../../../../assets/Wallet/view.png";
import receipt from "../../../../assets/Wallet/receipt.svg";
import EditIcon from "@mui/icons-material/Edit";
import CustomButton from "../../../../components/CustomButton";
import { showUnderDevelopment } from "../../../../components/Alert.js";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../../Utlis/Encryption";
import { BASE_URL } from "../../../../components/BaseUrl";
import StatusDropdown from "../../../../components/StatusDropdown";
import document1 from "../../../../assets/document1.svg"
import { convertUTCToLocalDateTime } from "../../../../components/dateTimeUtils.js";
const DetailsDrawer = ({ open, onClose, remunerationId }) => {
  const { t } = useTranslation();
  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;

  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState(null);

      const formatDateTime = (dateString) => {
  const formatted = convertUTCToLocalDateTime(dateString, {
    locale: "en-GB",
    formatOptions: {
      day: "2-digit",
      month: "short",
      year: "numeric",
    },
  });
  return formatted === "—" ? "-" : formatted;
};
  // fetch details
  useEffect(() => {
    if (!remunerationId) return;

    const fetchDetails = async () => {
      try {
        setLoading(true);
        const res = await fetch(
          `${BASE_URL}/company-admin/expenses/remuneration/${remunerationId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${decryptedToken}`,
            },
          }
        );
        const json = await res.json();
        console.log("payroll details ",json)

        if (!json.error && json.data) {
          setDetails(json.data);
        }
      } catch (err) {
        console.error("Error fetching remuneration details:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, [remunerationId, decryptedToken]);

  // ✅ Currency symbol helper
const getCurrencySymbol = (currencyCode) => {
  if (!currencyCode) return "";
  switch (currencyCode.toUpperCase()) {
    case "USD":
      return "$";
    case "EUR":
      return "€";

    default:
      return currencyCode; // fallback if unknown
  }
};

const isPdf = (url = "") => {
  return url.toLowerCase().endsWith(".pdf");
};
const attachmentUrl =
  details?.attachment_url || details?.expense?.receipt_url || "";
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: 550,
          maxWidth: "100%",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          backgroundColor: "#E7EBEE",
          p: 1.3,
          borderBottom: "1px solid #E0E0E0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.2 }}>
          <IconButton onClick={onClose}>
            <img src={profilecross} alt="close" />
          </IconButton>
          <CustomText
            sx={{
              ...textStyles.h1,
              fontSize: 20,
              fontWeight: 600,
              color: "#2C384C",
            }}
          >
  {t("salaryManagement.title")}          </CustomText>
        </Box>
      </Box>

      {/* Body */}
      <Box sx={{ p: 2, overflowY: "auto", flexGrow: 1 }}>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
            <CircularProgress />
          </Box>
        ) : details ? (
          <>
            {/* Status & Date */}
            <Box
              sx={{
                border: "1px solid #E4E6EF",
                borderRadius: 2,
                px: 2,
                py: 1,
                mb: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2,
                  mt: 1,
                }}
              >
                <CustomText     sx={{
                                ...textStyles.h1,
                                fontSize: 16,
                                fontWeight: 400,
                                color: "#5E5C5C",
                                textAlign: "left",
                              }}>
                  {t("salaryManagement.status")}
                </CustomText>

           
                <Box sx={{ pointerEvents: "none" }}>
                    
                    <StatusDropdown   currentStatus={
    details.expense?.status || details.status || "Paid"
  } />
                    </Box>
              </Box>

              <Box
                sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}
              >
                <CustomText     sx={{
                                ...textStyles.h1,
                                fontSize: 16,
                                fontWeight: 400,
                                color: "#5E5C5C",
                                textAlign: "left",
                              }}>
                  {t("salaryManagement.date")}
                </CustomText>
                <CustomText    sx={{
                                ...textStyles.h1,
                                fontSize: 15,
                                fontWeight: 400,
                                color: "#172B4D",
                                textAlign: "left",
                              }}>
                  {/* {details.paid_at
                    ? new Date(details.paid_at).toLocaleDateString("en-GB")
                    : "-"} */}
{formatDateTime(details.paid_at)}

                </CustomText>
              </Box>

              <Box
                sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}
              >
                <CustomText     sx={{
                                ...textStyles.h1,
                                fontSize: 16,
                                fontWeight: 400,
                                color: "#5E5C5C",
                                textAlign: "left",
                              }}>
                  {t("salaryManagement.comments")}
                </CustomText>
                <CustomText
                    sx={{
                                 ...textStyles.h1,
                                 fontSize: 15,
                                 fontWeight: 400,
                                 color: "#172B4D",
                                 textAlign: "left",
                               }}
                >
                  {details.note || details.expense?.decision_note || "-"}
                </CustomText>
              </Box>
            </Box>

            {/* Payment Details */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <CustomText
                       sx={{
                                 ...textStyles.h1,
                                 fontSize: 18,
                                 fontWeight: 600,
                                 color: "#000000",
                                 textAlign: "left",
                               }}
              >
                {t("salaryManagement.paymentDetails")}
              </CustomText>
              <img src={down} width={40} height={30} />
            </Box>

            <Box
              sx={{
                border: "1px solid #E4E6EF",
                borderRadius: 2,
                px: 2,
                py: 2,
                mt: 2,
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                <CustomText     sx={{
                                ...textStyles.h1,
                                fontSize: 16,
                                fontWeight: 400,
                                color: "#5E5C5C",
                                textAlign: "left",
                              }}>
                  {t("salaryManagement.workerName")}
                </CustomText>
                <CustomText    sx={{
                                ...textStyles.h1,
                                fontSize: 15,
                                fontWeight: 400,
                                color: "#172B4D",
                                textAlign: "left",
                              }}>
                  {details.worker?.name}
                </CustomText>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                <CustomText     sx={{
                                ...textStyles.h1,
                                fontSize: 16,
                                fontWeight: 400,
                                color: "#5E5C5C",
                                textAlign: "left",
                              }}>
                  {t("salaryManagement.paidAmount")}
                </CustomText>
                <CustomText    sx={{
                                ...textStyles.h1,
                                fontSize: 15,
                                fontWeight: 400,
                                color: "#172B4D",
                                textAlign: "left",
                              }}>
                  {/* {details.amount} */}
                    {getCurrencySymbol(details.currency || details.expense?.currency)}{" "}{details.amount} 

                </CustomText>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                <CustomText     sx={{
                                ...textStyles.h1,
                                fontSize: 16,
                                fontWeight: 400,
                                color: "#5E5C5C",
                                textAlign: "left",
                              }}>
                  {t("salaryManagement.description")}
                </CustomText>
                <CustomText
                  sx={{
                               ...textStyles.h1,
                               fontSize: 15,
                               fontWeight: 400,
                               color: "#172B4D",
                               textAlign: "left",
                             }}
                >
                  {details.expense?.description || "-"}
                </CustomText>
              </Box>
            </Box>

            {/* Receipt */}
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              sx={{ mt: 2 }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <CustomText
                  sx={{
                            ...textStyles.h1,
                            fontSize: 18,
                            fontWeight: 600,
                            color: "#000000",
                            textAlign: "left",
                          }}
                >
                  {t("salaryManagement.receipt")}
                </CustomText>
                <img src={down} width={40} height={30} />
              </Box>
              <Box>
                <img src={receipt} style={{ width: 30, height: 30 }} />
              </Box>
            </Box>

     <Box
  sx={{
    border: "1px solid #E4E6EF",
    borderRadius: 2,
    px: 2,
    py: 2,
    mt: 2,
    textAlign: "center",
  }}
>
  {/* {details.attachment_url ? (
    <a href={details.attachment_url} target="_blank" rel="noreferrer">
      <img
       crossOrigin="anonymous"
        src={details.attachment_url}
        alt="Receipt / Proof"
        style={{ maxWidth: "100%", maxHeight: 300, objectFit: "contain" }}
      />
    </a>
  ) : details.expense?.receipt_url ? (
    <a href={details.expense.receipt_url} target="_blank" rel="noreferrer">
      <img
             crossOrigin="anonymous"

        src={details.expense.receipt_url}
        alt="Receipt / Proof"
        style={{ maxWidth: "100%", maxHeight: 300, objectFit: "contain" }}
      />
    </a>
  ) : (
    <CustomText sx={{ fontSize: "16px" }}>No receipt available</CustomText>
  )} */}


  <Box
  sx={{
    border: "1px solid #E4E6EF",
    borderRadius: 2,
    px: 2,
    py: 2,
    mt: 2,
    textAlign: "center",
  }}
>
  {attachmentUrl ? (
    isPdf(attachmentUrl) ? (
      /* ===== PDF CASE ===== */
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
        }}
      >
        <img
          src={document1}
          alt="Document"
          style={{ width: 120, height: "auto" }}
        />

        <CustomText
          sx={{
            fontSize: 14,
            color: "#006EC2",
            cursor: "pointer",
            textDecoration: "underline",
          }}
          onClick={() => window.open(attachmentUrl, "_blank")}
        >
          View Document
        </CustomText>
      </Box>
    ) : (
      /* ===== IMAGE CASE ===== */
      <a href={attachmentUrl} target="_blank" rel="noreferrer">
        <img
          crossOrigin="anonymous"
          src={attachmentUrl}
          alt="Receipt / Proof"
          style={{
            maxWidth: "100%",
            maxHeight: 300,
            objectFit: "contain",
          }}
        />
      </a>
    )
  ) : (
    <CustomText sx={{ fontSize: 16 }}>
      {t("no_receipt_available")}
    </CustomText>
  )}
</Box>

</Box>


            
          </>
        ) : (
          <CustomText>No data found</CustomText>
        )}
      </Box>
    </Drawer>
  );
};

export default DetailsDrawer;
